import columnStyles from './columnsStyles.module.css';
import styles from './styles.module.css';
import UnlinkIcon from '@/assets/icons/unlink.svg?react';
import { DataTableColumn } from '@/components/DataTable';
import { Button } from '@/components/Form/Button';

export const getUsersColumns = <
  T extends {
    status?: string;
    name: string;
    lastName: string;
    email: string;
    userRole: string;
  }
>(
  showActions: boolean = true,

  onActionClick?: (item: T) => void,
  alignActions: 'left' | 'center' | 'right' = 'left'
): DataTableColumn<T>[] => {
  const baseColumns: DataTableColumn<T>[] = [
    {
      field: 'name',
      headerName: 'NAME',
      width: showActions ? '30%' : '33%',
      sortable: true,
      renderCell: ({ row }) => (
        <div
          className={`${styles.locationNameContainer} ${styles.underlineStyle}`}
        >
          {row.name || ''}
        </div>
      )
    },
    {
      field: 'email',
      headerName: 'EMAIL',
      width: showActions ? '30%' : '33%',
      sortable: true,
      renderCell: ({ row }) => (
        <div
          className={`${styles.locationNameContainer} ${styles.underlineStyle}`}
        >
          {row.email || ''}
        </div>
      )
    },
    {
      field: 'userRole',
      headerName: 'USER ROLE',
      width: showActions ? '24%' : '34%',
      sortable: true,
      renderCell: ({ row }) => (
        <div className={styles.locationNameContainer}>{row.userRole || ''}</div>
      )
    },
    {
      headerName: 'ACTIONS',
      width: '16%',
      renderCell: ({ row }) => (
        <div
          className={
            columnStyles[
              `header${alignActions.charAt(0).toUpperCase() + alignActions.slice(1)}`
            ]
          }
        >
          <Button
            label="UNASSIGN"
            icon={UnlinkIcon}
            iconPosition="right"
            onClick={() => onActionClick?.(row)}
            color="blue"
            solid={false}
            size="small"
            className={styles.unassignButton}
          />
        </div>
      )
    }
  ];

  if (showActions) {
    return baseColumns;
  } else {
    return baseColumns.filter(column => column.headerName !== 'ACTIONS');
  }
};
